var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Timer",class:_vm.time<=10 ? 'hurry' : ''},[_c('div',{staticClass:"timer-sec"},[_c('CanvasProgress',{attrs:{"target":_vm.targetTime,"progress":_vm.time}}),_vm._v(" "),_c('div',{staticClass:"image-section"}),_vm._v(" "),_c('div',{staticClass:"elapsedtime"},[_vm._v(_vm._s(_vm.elapsed))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f038ccaa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timer.vue
// module id = WbG4
// module chunks = 1